export default __webpack_public_path__ + "static/kv-0-4ba30346e22d2194074d5926230e7b34.png";